import { render, staticRenderFns } from "./profileLayout.vue?vue&type=template&id=4704f176&"
import script from "./profileLayout.vue?vue&type=script&lang=js&"
export * from "./profileLayout.vue?vue&type=script&lang=js&"
import style0 from "./profileLayout.vue?vue&type=style&index=0&id=4704f176&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VAlert,VCol,VRow,VSnackbar})
